import { AttachmentOutlined } from "@mui/icons-material";
import { Divider, useMediaQuery, useTheme } from "@mui/material";
import { grey } from "@mui/material/colors";
import { isEmpty, size } from "lodash";
import { useMemo, useState } from "react";
import { useFormState } from "react-final-form";
import RffFileUploadField from "../../components/finalForm/inputs/RffFileUploadField";
import RffGroup from "../../components/finalForm/shared/RffGroup";
import Flx from "../../components/layout/Flx";
import Txt from "../../components/typography/Txt";
import {
  fileDocGroups,
  getDocTypesByGroup,
} from "../../constants/fileDocGroupAndTypes";
import TitledLoanSection from "./TitledLoanSection";
import RffImportBorrowerDocumentsFromReduxButton from "../../components/finalForm/features/RffImportBorrowerDocumentsFromReduxButton";

const FileUploadSection = ({ testing }) => {
  const { values } = useFormState();
  const [group, setGroup] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const activeDocGroup = useMemo(() => fileDocGroups[group], [group]);

  const docGroups = useMemo(() => {
    if (isEmpty(values?.uploadMetadata)) {
      return fileDocGroups;
    }
    return fileDocGroups?.map((gp) => {
      const count = size(
        values?.uploadMetadata?.filter((f) => f?.docGroup === gp),
      );
      if (count === 0) {
        return gp;
      }
      return `${gp} (${count})`;
    });
  }, [values?.uploadMetadata]);

  return (
    <TitledLoanSection
      variant="h2"
      icon={<AttachmentOutlined className="thin" />}
      headerEndContent={<RffImportBorrowerDocumentsFromReduxButton />}
      title="File Upload"
      cardSx={{
        // p: 1,
        // pt: 1,

        "& .titled-group-body-root": {
          paddingLeft: 0.5,
        },
      }}
    >
      <RffGroup
        suppressBottomMargin
        headerSx={{ mb: 3 }}
        title="Property Related Documents"
        description="Upload any relevant documents pertaining to the property."
        // headerEndContent={
        //   <RffImportBorrowerDocumentsFromReduxButton
        //     docTypes={["Scope of Work", "Purchase Contract"]}
        //   />
        // }
      >
        <RffFileUploadField
          size={6}
          suppressButton
          label={"Scope of Work"}
          docType={"Scope of Work"}
          docGroup={"Construction Documents"}
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          suppressButton
          label={"Purchase Contract"}
          height="120px"
          docGroup={"Property Documents"}
          docType={"Purchase Contract"}
          borderSize={2}
        />
      </RffGroup>
      {/* <Divider sx={{ my: 2, borderColor: grey[200] }} /> */}
      <Divider sx={{ my: 6, borderColor: grey[200] }} />
      <RffGroup
        suppressBottomMargin
        title="Upload Related Entity Documents"
        headerSx={{ mb: 3 }}
        description="Upload any relevant documents pertaining to the entity."
        columnSpacing={5}
      >
        <RffFileUploadField
          size={6}
          label={"Articles of Organization"}
          docType={"Articles of Organization"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={"COGS"}
          docType={"COGS"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={"EIN"}
          docType={"EIN"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={"Operating Agreement"}
          docType={"Operating Agreement"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
      </RffGroup>
      <Divider sx={{ my: 6, borderColor: grey[200] }} />
      <RffGroup
        title="Additional Supporting Documents"
        description="If you have any additional documents related to this loan please upload them below"
        // description="If you have any additional documents that are related to this loan, please upload them below"
        suppressBottomMargin
        // headerEndContent={<RffImportBorrowerDocumentsFromReduxButton />}
        columnSpacing={5}
      >
        {/* <RffFileUploadField
          size={6}
          suppressButton
          label={"Scope of Work"}
          docType={"Scope of Work"}
          docGroup={"Construction Documents"}
          // name={`${docGroup}.${docType}`}
          // uploadText={"Entity Docs"}
          // size={getSize(docType)}
          height="120px"
          // docType={docType}
          // docGroup={docGroup}

          borderSize={2}

          // required={testing?.required}
        />
        <RffFileUploadField
          size={6}
          suppressButton
          label={"Purchase Contract"}
          height="120px"
          docGroup={"Property Documents"}
          docType={"Purchase Contract"}
          borderSize={2}
        /> */}
        <RffFileUploadField
          // label={"Additional Related Documents"}
          height="120px"
          suppressButton
          excludeDocGroups={["Entity Docs"]}
          excludeDocTypes={["Purchase Contract", "Scope of Work"]}
          borderSize={2}
          suppressIcon
        />
      </RffGroup>
      {/* <Flx gap={2} column={isMobile} fw>
        {isMobile ? (
          <Box sx={{ width: "100%", overflowX: "auto", mr: "-14px" }}>
            <ToggleTabSwitcher
              orientation="horizontal"
              tabs={docGroups}
              value={group}
              onChange={setGroup}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.4,
                ".MuiButtonBase-root.MuiToggleButtonGroup-grouped": {
                  border: `1px solid ${theme.palette.grey[300]}`,
                  borderRadius: "4px !important",
                  flexGrow: 1,
                },
              }}
              useIndex
            />
          </Box>
        ) : (
          <ToggleTabSwitcher
            orientation="vertical"
            tabs={docGroups}
            value={group}
            onChange={setGroup}
            useIndex
          />
        )}
        <Box sx={{ p: 1, pt: 0 }}>
          <RffDocGroupTypes docGroup={activeDocGroup} />
        </Box>
      </Flx> */}
    </TitledLoanSection>
  );
};

const RffDocGroupTypes = ({ docGroup }) => {
  const docTypes = useMemo(() => getDocTypesByGroup(docGroup), [docGroup]);

  if (isEmpty(docTypes)) {
    return (
      <Flx column fw g={2}>
        <Txt body2>
          No document types available for this group. Please select another
          group.
        </Txt>
      </Flx>
    );
  }
  return (
    <Flx column fw g={2}>
      <Flx column sx={{ mt: 1 }}>
        <Txt bold>{docGroup}</Txt>
        <Txt body2>
          Drag & drop or click the following boxes to upload files.
        </Txt>
      </Flx>
      <RffGroup columnSpacing={1} suppressBottomMargin rowSpacing={1}>
        <RffFileUploadField
          name={`${docGroup}`}
          uploadText={`Unassigned ${docGroup}`}
          size={12}
          height="100px"
          docGroup={docGroup}
          background={grey[50]}
          suppressButton
          sx={{
            ".file-upload-text": {
              fontWeight: 700,
            },
          }}
        />
        {docTypes?.map((docType) => {
          const getSize = (type) => {
            if (size(docTypes) <= 5) {
              return 12;
            }

            return 6;
          };
          return (
            <RffFileUploadField
              key={docType}
              name={`${docGroup}.${docType}`}
              uploadText={docType}
              size={getSize(docType)}
              height="64px"
              docType={docType}
              docGroup={docGroup}
              // suppressButton
              suppressButton
              borderSize={2}
              suppressIcon
              // required={testing?.required}
            />
          );
        })}
      </RffGroup>
    </Flx>
  );
};

export default FileUploadSection;
